import { render, staticRenderFns } from "./Ssh.vue?vue&type=template&id=8288120a&scoped=true&"
import script from "./Ssh.vue?vue&type=script&lang=js&"
export * from "./Ssh.vue?vue&type=script&lang=js&"
import style0 from "./Ssh.vue?vue&type=style&index=0&id=8288120a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8288120a",
  null
  
)

export default component.exports